import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../Footer';
import { ContainerWrapper } from './style';
import useCurrentLang from '@/hooks/useCurrentLang';
import useResize from '@/hooks/useResize';
import { getFeatureDetail } from '@/api/frontData.api';
import { Flex, LoadingPage } from '@/layout';
import { errorHandler } from '@/utils/toastHandler';
import { Link, useParams } from 'react-router-dom';
import { sify } from 'chinese-conv/dist';
import { Button } from '@/components/UI/Button';
import { Text } from '@/components/UI/Typography/Text';
import { theme } from '@/theme/Theme';
import PATH from '@/router/path';

const FeatureDetail = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const lang = useCurrentLang();
  const { isTablet, isMobile } = useResize();
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();

  const [featureDetail, setFeatureDetail] = useState<BannerFeature>();

  const initData = async () => {
    if (!id) return;
    setIsLoading(true);
    try {
      const res = (await getFeatureDetail(id)).data;
      setFeatureDetail(res);
    } catch (error) {
      console.log(error);
      errorHandler(t('error.server'));
    } finally {
      setIsLoading(false);
      // 將畫面滾動至最上方
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    initData();
  }, [lang, id]);

  return (
    <>
      <ContainerWrapper isTablet={isTablet} isMobile={isMobile}>
        {isLoading ? (
          <LoadingPage isLoading={isLoading} />
        ) : featureDetail ? (
          <>
            <div className="title">
              <h1>
                {lang === 'en'
                  ? featureDetail.title_en
                  : lang === 'tc'
                    ? featureDetail.title
                    : sify(featureDetail.title)}
              </h1>
            </div>
            <div className="info">
              <div
                className="content"
                dangerouslySetInnerHTML={{
                  __html: lang === 'en' ? featureDetail.info_en : lang === 'tc' ? featureDetail.info : sify(featureDetail.info),
                }}
              />
            </div>
            <Flex gridGap={'15px'} alignItems={'center'} marginTop={50}>
              <Link to={PATH.auth.signUp}>
                <Button
                  size={'lg'}
                  variant={'primary'}
                  rounded={false}
                >
                  {t('buttons.registerNow')}
                </Button>
              </Link>
              <a target="_blank" href='https://wa.me/85266981322' rel="noreferrer">
                <Text
                  fontSize={theme.fontSizes.md}
                  color={theme.colors.primary500}
                  style={{ textDecoration: 'underline', cursor: 'pointer' }}
                >
                  {t('buttons.contactUsForATrail')}
                </Text>
              </a>
            </Flex>
          </>
        ) : (
          <></>
        )}
      </ContainerWrapper>
      <Footer />
    </>
  );
};

export default FeatureDetail;
